export default "__VITE_ASSET__kHrNw0zh__"